import { render, staticRenderFns } from "./serveOrder.vue?vue&type=template&id=3ce544b4&scoped=true&"
import script from "./serveOrder.vue?vue&type=script&lang=js&"
export * from "./serveOrder.vue?vue&type=script&lang=js&"
import style0 from "./serveOrder.vue?vue&type=style&index=0&id=3ce544b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce544b4",
  null
  
)

export default component.exports